import React, {memo} from 'react'
import {connect} from 'react-redux'
import cx from 'classnames'

/* Cosmos */
import Button from '@cosmos/button'

/* Config */
import appConfig from '../../../../appConfig'

/* Constants */
import {ADD_TO_CART_BUTTON_TEXT} from '../../../../modules/product/productDesktopConstants'
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'
import {CART_ACTION_STATE} from '../../../../modules/cart/cartConstants'
import {EVENT_BUS_NAMES} from '../../../../modules/product/productDesktopConstants'
import {DESKTOP_COMPONENTS, DESKTOP_COMPONENTS_OPTIONS} from '../../../../modules/voltran/voltranConstants'

/* Components */
import VoltranFragment from '../../../../components/VoltranFragment/VoltranFragment'

/* Utils */
import {generateExperiments} from '../../../../modules/analytics/analyticsUtils'
import {yieldToMain} from '../../../../utils/performance'
import leoProductEvents from '../../../../events/leo/productEvents';

/* Actions */
import {actionCreators as pendingActionCreators} from '../../../../redux/actions/pendingActions'
import {actionCreators as productActionCreators} from '../../../../redux/actions/productActions'

/* Styles */
import s from './add-to-cart.scss'

const AddToCart = memo(({
  className,
  dispatch,
  name,
  sku,
  listingId,
  categoryId,
  categoryName,
  merchantId,
  merchantName,
  productId,
  categories,
  isPreOrder,
  isInStock,
  imageUrl,
  listings,
  customerReviewCount,
  customerReviewScore,
  isAddToCartPending,
  isBundle,
  isAvailableProduct,
  selectedVasProduct,
  fragmentsMap,
  price,
  categoryUrlKeyword
}) => {

  const handleAddToCartClick = async() => {
    sendAddToCartClickEvent()
    await yieldToMain()
    if (process.env.BROWSER && window?.Checkout?.AddToCart) {
      dispatch(pendingActionCreators.setPendingState(CART_ACTION_STATE, true))
      window.Checkout.AddToCart({
        listingId: listingId || '',
        sku: sku || '',
        imageUrl: imageUrl,
        name: name || '',
        merchantName: merchantName || '',
        continueShoppingLink: `/${categoryUrlKeyword}-c-${categoryId}`,
        quantity: 1,
        ...selectedVasProduct && {
          relatedProduct: {
            sku: selectedVasProduct?.sku,
            listingId: selectedVasProduct?.listingId,
            quantity: selectedVasProduct?.quantity,
            vasType: selectedVasProduct?.vasTypeId,
            staticPage: selectedVasProduct?.staticPage
          }
        }
      },
      'SfProductDetail',
      {
        callback: () => {
          dispatch(pendingActionCreators.setPendingState(CART_ACTION_STATE, false))
          window?.HbEventBus?.emit(EVENT_BUS_NAMES.VAS_RESET, false)
          dispatch(productActionCreators.setRemoveAllVasProduct.trigger())
          dispatch(productActionCreators.setRemoveVasProduct.trigger())
        },
        errorHandler: () => {
          dispatch(pendingActionCreators.setPendingState(CART_ACTION_STATE, false))
          console.error('Checkout Voltran Add To Cart Error');
        },
      })
    }
  }

  const sendAddToCartClickEvent = () => {
    let data = {
      canonical_url: window?.utagData ? window.utagData.canonical_url : '',
      category: categories?.length > 0 ? {
        item: categoryId || '',
        name: categoryName || '',
      } : null,
      category_hierarchy: categories?.map(item => ({
        id: item?.categoryId || '',
        name: item?.categoryName || '',
      })),
      category_status: '',
      experiments: generateExperiments(),
      listings: listings || [],
      location: 'Buybox',
      merchant: merchantName || '',
      merchantId: merchantId,
      page_type: 'pdp',
      page_value: sku,
      products: [{
        campaignId: '',
        id: productId || '',
        listingId: listingId || '',
        mainProduct: false,
        merchantId: merchantId,
        name: name,
        position: 1,
        price: `${price}`,
        quantity: 1,
        sku: sku || '',
      }],
      customerReviewCount: customerReviewCount || '',
      review_rate: customerReviewScore || '',
    };

    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.ADD_TO_CART_CLICK, data, generateExperiments());
    leoProductEvents.sendAddToCartClickEvent({
      productId:  productId || '',
      position: 1,
      sku: sku || '',
      location: 'buy_box',
    })
  }

  const generateButtonProps = () => {
    if (isPreOrder) {
      return {
        text: ADD_TO_CART_BUTTON_TEXT.IS_PRE_ORDER,
        kind: 'tertiary',
      }
    }

    if (!isInStock) {
      return {
        text: ADD_TO_CART_BUTTON_TEXT.IS_IN_STOCK,
        kind: 'quaternary',
      }
    }

    return {
      text: ADD_TO_CART_BUTTON_TEXT.DEFAULT,
      kind: 'primary',
    }
  }

  return (
    <div className={cx(s.root, className)} data-test-id={'add-to-cart'}>
      <Button
        className={s.addToCart}
        prefix={appConfig.cosmosPrefix}
        data-test-id={'addToCart'}
        kind={generateButtonProps()?.kind}
        disabled={isAddToCartPending || !isAvailableProduct || isBundle}
        loading={isAddToCartPending}
        size={'default'}
        onClick={handleAddToCartClick}>
        <i/>
        {generateButtonProps()?.text}
      </Button>
      {
        fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.MY_LIST]?.id?.toString()) &&
        <div>
          <VoltranFragment
            fragmentInfo={fragmentsMap?.get(DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.MY_LIST]?.id?.toString())}
            options={DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.MY_LIST]}
            renderMethodClientSide={process.env.BROWSER}
            removeClientStyles/>
        </div>
      }
    </div>
  )
})


const mapStateToProps = (state) => {
  const {
    pendingState: {
      isAddToCartPending
    }
  } = state

  return {
    isAddToCartPending
  }
}

export default connect(mapStateToProps)(AddToCart)
